/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";

import { Col, Nav, Row, Tab } from "react-bootstrap";

import { IItbi } from "../../../../shared/providers/itbi/interfaces";
import { ItbiApiService } from "../../../../shared/services/api/itbi-api.service";
import { ItbiHistory } from "./tabs/history";
import { ItbiEditableYear } from "./tabs/editable-year";
import { useAuth } from "../../../../shared/hooks/useAuth";
import { FeaturesEnum } from "../../../../shared/enums/features.enum";

interface ItbiInfoProps {
    info: Record<string, string>;
}

export const ItbiInfo: React.FC<ItbiInfoProps> = ({ info }) => {
    const [itbis, setItbis] = useState<IItbi[]>([]);
    const [loading, setLoading] = useState(false);
    const years = [2025, 2024, 2023, 2022];
    const currentYear = new Date().getFullYear();
    const { user } = useAuth();
    const fetchItbi = useCallback(async () => {
        if (!info) return;

        setLoading(true);
        try {
            const itbisList = await ItbiApiService.getItbi(info.cadastrogeral);
            setItbis(itbisList.data);
        } finally {
            setLoading(false);
        }
    }, []);

    const doAfterSubmitEdit = () => {
        fetchItbi();
    };

    useEffect(() => {
        if (info.cadastrogeral) {
            fetchItbi();
        }
    }, [fetchItbi]);

    if (loading) return null;

    return (
        <Tab.Container defaultActiveKey={`history-${currentYear}`}>
            <Row>
                <Col sm={3}>
                    <Nav variant="pills" className="flex-column">
                        {years.map((year) => (
                            <Nav.Item as="button" key={year}>
                                <Nav.Link eventKey={`history-${year}`}>
                                    HISTÓRICO ITBI ({year})
                                </Nav.Link>
                            </Nav.Item>
                        ))}
                        <Nav.Item as="button">
                            <Nav.Link eventKey="editable">
                                ADICIONAR/EDITAR
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col>
                    <Tab.Content
                        style={{
                            height: "400px",
                            margin: 0,
                            overflowX: "hidden",
                            overflowY: "auto",
                        }}
                    >
                        {user.authorizationsByFeatureName[FeaturesEnum.ITBI]
                            ?.canRead && (
                            <>
                                {years.map((year) => (
                                    <Tab.Pane
                                        eventKey={`history-${year}`}
                                        key={year}
                                    >
                                        <ItbiHistory
                                            data={itbis}
                                            ano={year.toString()}
                                        />
                                    </Tab.Pane>
                                ))}
                                <Tab.Pane eventKey="editable">
                                    <ItbiEditableYear
                                        info={info}
                                        data={itbis}
                                        lastYear="2025"
                                        doAfterSubmit={doAfterSubmitEdit}
                                    />
                                </Tab.Pane>
                            </>
                        )}
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    );
};
